import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importing and using files in the order they appear inside the i18n folders
import enCommon from "./en/common";
import enLeadGeneration from "./en/leadGeneration";
import enLocalContent from "./en/localContent";
import enLocalDemographics from "./en/localDemographics";
import enNeighborhoodCharacteristics from "./en/neighborhoodCharacteristics";
import enNeighborhoodDemographics from "./en/neighborhoodDemographics";
import enNeighborhoodFeatured from "./en/neighborhoodFeatured";
import enNeighborhoodHero from "./en/neighborhoodHero";
import enNeighborhoodHighlights from "./en/neighborhoodHighlights";
import enNeighborhoodMap from "./en/neighborhoodMap";
import enNeighborhoodMarketTrends from "./en/neighborhoodMarketTrends";
import enNeighborhoodMatch from "./en/neighborhoodMatch";
import enNeighborhoodPropertyValueDrivers from "./en/neighborhoodPropertyValueDrivers";
import enNeighborhoodSchools from "./en/neighborhoodSchools";
import enNeighborhoodShowcase from "./en/neighborhoodShowcase";

import frCommon from "./fr/common";
import frLeadGeneration from "./fr/leadGeneration";
import frLocalContent from "./fr/localContent";
import frLocalDemographics from "./fr/localDemographics";
import frNeighborhoodCharacteristics from "./fr/neighborhoodCharacteristics";
import frNeighborhoodDemographics from "./fr/neighborhoodDemographics";
import frNeighborhoodFeatured from "./fr/neighborhoodFeatured";
import frNeighborhoodHero from "./fr/neighborhoodHero";
import frNeighborhoodHighlights from "./fr/neighborhoodHighlights";
import frNeighborhoodMap from "./fr/neighborhoodMap";
import frNeighborhoodMarketTrends from "./fr/neighborhoodMarketTrends";
import frNeighborhoodMatch from "./fr/neighborhoodMatch";
import frNeighborhoodPropertyValueDrivers from "./fr/neighborhoodPropertyValueDrivers";
import frNeighborhoodSchools from "./fr/neighborhoodSchools";
import frNeighborhoodShowcase from "./fr/neighborhoodShowcase";

export const resources = {
  common: enCommon,
  leadGeneration: enLeadGeneration,
  localContent: enLocalContent,
  localDemographics: enLocalDemographics,
  neighborhoodCharacteristics: enNeighborhoodCharacteristics,
  neighborhoodDemographics: enNeighborhoodDemographics,
  neighborhoodFeatured: enNeighborhoodFeatured,
  neighborhoodShowcase: enNeighborhoodShowcase,
  neighborhoodHero: enNeighborhoodHero,
  neighborhoodHighlights: enNeighborhoodHighlights,
  neighborhoodMap: enNeighborhoodMap,
  neighborhoodMatch: enNeighborhoodMatch,
  neighborhoodPropertyValueDrivers: enNeighborhoodPropertyValueDrivers,
  neighborhoodMarketTrends: enNeighborhoodMarketTrends,
  neighborhoodSchools: enNeighborhoodSchools,
};

i18n.use(initReactI18next).init({
  debug: import.meta.env.VITE_LOCALIZATION_DEBUG === "true",
  fallbackLng: "en",
  returnEmptyString: false,
  supportedLngs: ["en", "fr"],
  resources: {
    en: {
      common: enCommon,
      leadGeneration: enLeadGeneration,
      localContent: enLocalContent,
      localDemographics: enLocalDemographics,
      neighborhoodCharacteristics: enNeighborhoodCharacteristics,
      neighborhoodDemographics: enNeighborhoodDemographics,
      neighborhoodFeatured: enNeighborhoodFeatured,
      neighborhoodShowcase: enNeighborhoodShowcase,
      neighborhoodHero: enNeighborhoodHero,
      neighborhoodHighlights: enNeighborhoodHighlights,
      neighborhoodMap: enNeighborhoodMap,
      neighborhoodMatch: enNeighborhoodMatch,
      neighborhoodPropertyValueDrivers: enNeighborhoodPropertyValueDrivers,
      neighborhoodMarketTrends: enNeighborhoodMarketTrends,
      neighborhoodSchools: enNeighborhoodSchools,
    },
    fr: {
      common: frCommon,
      leadGeneration: frLeadGeneration,
      localContent: frLocalContent,
      localDemographics: frLocalDemographics,
      neighborhoodCharacteristics: frNeighborhoodCharacteristics,
      neighborhoodDemographics: frNeighborhoodDemographics,
      neighborhoodFeatured: frNeighborhoodFeatured,
      neighborhoodShowcase: frNeighborhoodShowcase,
      neighborhoodHero: frNeighborhoodHero,
      neighborhoodHighlights: frNeighborhoodHighlights,
      neighborhoodMap: frNeighborhoodMap,
      neighborhoodMatch: frNeighborhoodMatch,
      neighborhoodPropertyValueDrivers: frNeighborhoodPropertyValueDrivers,
      neighborhoodMarketTrends: frNeighborhoodMarketTrends,
      neighborhoodSchools: frNeighborhoodSchools,
    },
  },
});

export default i18n;
